import { IProps, Textbox } from "../Textbox";
import styles from "./TitleInput.scss";

export class TitleInput extends Textbox {
    constructor(props: IProps) {
        super(props, styles.titleInput, true);
    }
}

export default TitleInput;


// WEBPACK FOOTER //
// ./src/Components/Common/Input/TextBoxes/TitleInput/TitleInput.tsx